import { Controller } from "@hotwired/stimulus"

// Expands and collapses a rich-text block. The full text is always in the HTML
// (search engines index it); collapsing is pure CSS keyed on data-expanded.
export default class extends Controller {
  static targets = ["button"]
  static values = { moreLabel: String, lessLabel: String }

  toggle() {
    const expanded = !("expanded" in this.element.dataset)

    if (expanded) {
      this.element.dataset.expanded = ""
    } else {
      delete this.element.dataset.expanded
    }

    this.buttonTarget.textContent = expanded ? this.lessLabelValue : this.moreLabelValue
    this.buttonTarget.setAttribute("aria-expanded", expanded)
  }
}
